import { useContext } from 'react'
import { StripeSetupContext } from '../providers/StripeSetupProvider'

export const useStripeSetup = () => {
  return useContext(StripeSetupContext)
}
